export default __webpack_public_path__ + "static/media/logo_burger_menu_color.f7faaa4b.png";